(() => {
  if (customElements.get('og-selling-plans')) return;
  customElements.define('og-selling-plans', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.form = this.closest('form');
      this.options = this.querySelector('[data-og-plan-options]');
      this.selection = this.form.querySelector('[data-variant-selection]');
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.options.addEventListener('change', () => this.describe(), options);
      this.form.addEventListener('change', event => {
        if (!this.options.contains(event.target)) this.sync();
      }, options);
      this.form.addEventListener('variant-change', () => this.sync(), { ...options, capture: true });
      this.form.addEventListener('submit', () => this.sync(), { ...options, capture: true });
      if (this.selection) {
        this.observer = new MutationObserver(() => this.sync());
        this.observer.observe(this.selection, { attributes: true, attributeFilter: ['variant'] });
      }
      this.sync();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.bound = false;
    }
    sync() {
      const id = this.selection?.getAttribute('variant') || this.form.querySelector('[name="id"]')?.value;
      if (id !== this.variantId) {
        const previous = this.options.querySelector(':checked')?.value;
        const template = Array.from(this.querySelectorAll('template')).find(item => item.dataset.ogPlanVariant === id);
        this.options.replaceChildren(...(template ? [template.content.cloneNode(true)] : []));
        const radios = Array.from(this.options.querySelectorAll('input[type=radio]'));
        const retained = radios.find(radio => radio.value === previous);
        if (retained) retained.checked = true;
        this.variantId = id;
        this.hidden = !template || !radios.length;

      }
      this.describe();
    }
    describe() {
      const note = this.form.querySelector('[data-og-subscription-note]');
      if (note) note.hidden = !this.options.querySelector(':checked')?.value;
    }
  });
})();
